
import Aos from "aos";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import DefaultLayout from "./components/layouts/DefaultLayout";
import About from "./pages/About";
import Article from "./pages/Article";
import ArticleDetail from "./pages/Article/ArticleDetail";
import ArticleFilter from "./pages/Article/ArticleFilter";
import ArticleList from "./pages/Article/ArticleList";
import ArticleSearch from "./pages/Article/ArticleSearch";
import ArticleTag from "./pages/Article/ArticleTag";
import Gallery from "./pages/Gallery";
import DetailGallery from "./pages/Gallery/DetailGallery";
import MainGallery from "./pages/Gallery/MainGallery";
import Landing from "./pages/Landing";
import Product from "./pages/Product";
import PerCategory from "./pages/Product/PerCategory";
import ProductList from "./pages/Product/ProductList";
import Service from "./pages/Services";
import ServiceList from "./pages/Services/ServiceList";
import Request from "./pages/Request";
import RequestList from "./pages/Request/RequestList";
import AVDesign from "./pages/Services/av-design";
import ProductCustomize from "./pages/Services/product-customize";
import Installasi from "./pages/Services/installasi";
import ServiceCenter from "./pages/Services/service-center";

function App() {
  useEffect(() => {
    Aos.init();
  }, [])

  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return (
    <Routes>
      <Route path="/gallery/:slug" element={<DetailGallery />} />
      <Route path="/" element={<DefaultLayout />}>
        <Route index element={<Landing />} />
        <Route path="about" element={<About />} />
        <Route path="/gallery" element={<Gallery />}>
          <Route index element={<MainGallery />} />
        </Route>
        <Route path="/articles" element={<Article />}>
          <Route index element={<ArticleList />} />
          <Route path="category/:slug" element={<ArticleFilter />} />
          <Route path="search/:slug" element={<ArticleSearch />} />
          <Route path=":slug" element={<ArticleDetail />} />
          <Route path="/articles/tag/:tag" element={<ArticleTag />} />
        </Route>
        <Route path="/request" element={<Request />}>
          <Route index element={<RequestList />} />
        </Route>
        <Route path="/services" element={<Service />}>
          <Route index element={<ServiceList />} />
          <Route path="/services/av-design" element={<AVDesign />} />
          <Route path="/services/product-customize" element={<ProductCustomize />} />
          <Route path="/services/installasi" element={<Installasi />} />
          <Route path="/services/service-center" element={<ServiceCenter />} />
        </Route>
        <Route path="/product" element={<Product />}>
          <Route index element={<ProductList />} />
        </Route>
        <Route path="/ctg" element={<Product />}>
          <Route path=":slug" element={<PerCategory />} />
        </Route>
        {/* <Route path="/search" element={<Product />}>
          <Route path=":keyword" element={<ProductSearch />} />
        </Route> */}
      </Route>
    </Routes>
  )
}

export default App;
